// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"e3ebe3ee","186":"dc725ab4","344":"eaadb338","372":"8801566d","377":"2d004c18","738":"5ae825ce","841":"f90a77ab","856":"212bf4a0"}[chunkId] + ".chunk.js";
};